import LogOutFormModal from './LogOutFormModal';

export default LogOutFormModal;


// WEBPACK FOOTER //
// ./src/components/LogOutFormModal/index.jsx